// Central Chart.js registration.
// Import this module once (at app bootstrap) so every chart component can rely
// on the required Chart.js building blocks being registered, instead of each
// component registering them on its own.
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  RadialLinearScale,
  Filler,
} from "chart.js";
import AnnotationPlugin from "chartjs-plugin-annotation";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  RadialLinearScale,
  Filler,
  AnnotationPlugin
);

export default ChartJS;
